import React from 'react';
import { Phone, Mail, UserCircle, QrCode } from 'lucide-react';
import { PHONE_NUMBER, PHONE_TEL_HREF, EMAIL_ADDRESS, IDX_LOGIN_URL, IDX_SIGNUP_URL } from '../../constants/site';
import { LANDING_PAGES } from '../../constants/landingPages';
import { InstallAppLink } from '../InstallAppLink';

const Heading = ({ children }) => <h4 className="text-gold-400 font-bold text-sm uppercase tracking-wider">{children}</h4>;
const LINK_CLS = 'text-white/80 hover:text-gold-400 transition-colors';

const IconRow = ({ href, icon: Icon, children }) => {
  const cls = 'flex items-center justify-center md:justify-start space-x-3 text-white hover:text-gold-400 transition-colors group';
  const inner = (
    <>
      <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center group-hover:bg-gold-400/20 transition-colors"><Icon className="w-5 h-5" /></div>
      {children}
    </>
  );
  return href ? <a href={href} className={cls}>{inner}</a> : <div className={cls}>{inner}</div>;
};

export const ContactColumn = () => (
  <div className="text-center md:text-left space-y-4">
    <Heading>Contact</Heading>
    <div className="space-y-3">
      <IconRow href={PHONE_TEL_HREF} icon={Phone}><span className="font-semibold">{PHONE_NUMBER}</span></IconRow>
      <IconRow href={`mailto:${EMAIL_ADDRESS}`} icon={Mail}><span className="text-sm">{EMAIL_ADDRESS}</span></IconRow>
      <IconRow icon={UserCircle}>
        <span className="text-sm font-semibold">
          <a href={IDX_LOGIN_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-sign-in-link" className="hover:text-gold-400 transition-colors">Client Login</a>
          {' / '}
          <a href={IDX_SIGNUP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-create-account-link" className="underline hover:text-gold-400 transition-colors">Create Free Account</a>
        </span>
      </IconRow>
      <InstallAppLink className="justify-center md:justify-start text-white/80 hover:text-gold-400 transition-colors text-sm font-semibold min-h-[44px]" />
    </div>
  </div>
);

export const OfficeColumn = () => (
  <div className="text-center space-y-4">
    <Heading>Office</Heading>
    <div className="space-y-2 text-white/80 text-sm">
      <p className="font-semibold text-white">Swell Realty Co.</p>
      <p>2122 General Booth Blvd Suite 104</p>
      <p className="text-white/60">Open Mon–Sun · 8:00 AM – 8:00 PM</p>
      <p>Virginia Beach, VA 23454</p>
      <p className="text-white/60 pt-2">Serving Virginia Beach, the Outer Banks &amp; Coastal VA / NC</p>
    </div>
    <a href="/open-house/qr" data-testid="footer-open-house-tool" className="inline-flex items-center space-x-2 text-white/50 hover:text-gold-400 text-xs transition-colors">
      <QrCode className="w-3.5 h-3.5" /><span>Open House Sign-In QR</span>
    </a>
  </div>
);

export const GuidesColumn = () => (
  <div className="text-center md:text-left space-y-4">
    <Heading>Guides &amp; Neighborhoods</Heading>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-x-4 gap-y-2 text-sm" data-testid="footer-guides">
      {LANDING_PAGES.map((pg) => (
        <a key={pg.slug} href={`/${pg.slug}`} data-testid={`footer-guide-${pg.slug}`} className={LINK_CLS}>{pg.footerLabel}</a>
      ))}
      <a href="/sell/23454" className={LINK_CLS}>23454 Home Values</a>
      <a href="/home-value" className={LINK_CLS}>Free Home Valuation</a>
    </div>
  </div>
);

export const QuickLinksColumn = ({ navItems }) => (
  <div className="text-center md:text-right space-y-4">
    <Heading>Quick Links</Heading>
    <div className="flex flex-wrap justify-center md:justify-end gap-x-4 gap-y-2 text-sm">
      {navItems.map((item) =>
        item.type === 'scroll' ? (
          <button key={item.label} onClick={item.action} className={LINK_CLS}>{item.label}</button>
        ) : (
          <a key={item.label} href={item.href} target={item.internal ? undefined : '_blank'} rel={item.internal ? undefined : 'noopener noreferrer'} className={LINK_CLS}>{item.label}</a>
        ),
      )}
    </div>
  </div>
);
